import React, { useState } from 'react'
import { useData } from 'utils/context'
import { getSearchAll, getCurrentStore, clearSession } from 'utils/selectors'
import firebase from 'utils/firebase'
import { routes } from 'utils/constants'
import { fetchEmployee } from 'utils/firestore/employees'
import { useRouter } from 'next/router'
import { makeUser } from 'utils/helpers'

export const hydrateClientState = () => {
  return {
    searchAll: getSearchAll(),
    currentStore: getCurrentStore()
  }
}

const useHydrateFromStorage = () => {
  const [loading, setLoading] = useState(true)
  const { dispatchUser, dispatchSearchAll, dispatchCurrentStore, currentStore, user } = useData()
  const router = useRouter()
  const getUserInfo = async () => {
    let currentUser = user
    try {
      setLoading(true)
      let authUser = firebase.auth().currentUser
      if (!authUser) {
        clearSession()
        await router.push(routes.login)
        return null
      } 
      if (!currentUser) {
        const { claims: userClaims } = await authUser.getIdTokenResult(true)
        let claims = userClaims
        if (!Object.keys(claims).includes('storeIds')) {
          let employee = await fetchEmployee(authUser.email)
          claims = { ...employee, storeIds: employee.stores }
        }
        currentUser = makeUser({ user: authUser, claims })
        dispatchUser(currentUser)
      }
      let store = null
      const localStore = getCurrentStore()
      if (localStore && currentUser?.storeIds?.includes(localStore?.id)) {
        store = localStore
      } else if (currentUser?.defaultStore) {
        store = currentUser?.defaultStore
      } else {
        store = currentUser?.stores[0]
        dispatchSearchAll(true)
      }
      if (!currentStore) dispatchCurrentStore(store)
    } catch (e) {
      console.log(e)
    }
    finally {
      setLoading(false)
    }

  }
  React.useEffect(() => {
    getUserInfo()
  }, [])

  return { loading }
}

export default useHydrateFromStorage
